import { cn } from "@synthesis/shared-utils";
import { observer } from "mobx-react-lite";
import { usePageStore } from "../applications-page.lib";

type FoundItemsCountProps = {
  className?: string;
};

export const FoundItemsCount = observer(({ className }: FoundItemsCountProps) => {
  const pageStore = usePageStore();

  return (
    <p className={cn("subtitle-sm text-type-light", className)}>
      Записей: <span className="text-type-common">{pageStore?.totalItemsCount ?? 0}</span>
    </p>
  );
});
